import {
    ADJUSTMENTS_FETCH,
    ADJUSTMENTS_IS_FETCING,
    ADJUSTMENTS_API,
    ADJUSTMENT_EDIT,
    ADJUSTMENT_FILTER,
    SET_ADJUSTMENT_VIEW_FILTER,
    UPDATE_ADJUSTMENT_STATUS
} from 'constants/adjustments'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const adjustmentSave = (data) => (dispatch, state) => {
    let action;
    if (data.adjustmentId)
        action = put;
    else
        action = post;
    dispatch(adjustmentsIsFetching(true))
    return action(ADJUSTMENTS_API, data)
        .then((e) => { dispatch(adjustmentsIsFetching(false)); return e; })
        .catch((e) => { dispatch(adjustmentsIsFetching(false)); throw new Error(e) })
}

export const adjustmentFetch = (id) => (dispatch, state) => {
        dispatch(adjustmentsIsFetching(true));
        return get(ADJUSTMENTS_API + '/' + id)
            .finally(e => dispatch(adjustmentsIsFetching(false)))

    }

export const adjustmentsFetch = (ibId=null, from=null, to=null,status=null, loading=true) => (dispatch, state) => {
    dispatch(adjustmentsIsFetching(loading));
    const filter = state().adjustments.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        };

    if ((ibId !== undefined) && ((ibId !== null) && (ibId !== 0))) {
        params.ibId = ibId;
    }
    if ((from !== undefined) && (from !== null)) {
        params.from = from;
    }
    if ((to !== undefined) && (to !== null)) {
        params.to = to;
    }
    if ((status !== undefined) && (status !== null)) {
        params.status = status;
    }
    return get(ADJUSTMENTS_API, params)
        .then((e) => {
            dispatch(adjustmentsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                adjustmentFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(adjustmentsIsFetching(false)))
}


export const declineAdjustment = (id,comment) => (dispatch, state) => {
	dispatch(adjustmentsIsFetching(true))
    return post(ADJUSTMENTS_API + '/decline/' + id + '?comment=' + comment)
            .then((data) => dispatch(updateAdjustmentStatus(data)))
			.finally(e => dispatch(adjustmentsIsFetching(false)))
}

export const approveAdjustment = (id,comment) => (dispatch, state) => {
	dispatch(adjustmentsIsFetching(true))
    return post(ADJUSTMENTS_API + '/approve/' + id + '?comment=' + comment)
            .then((data) => dispatch(updateAdjustmentStatus(data)))
			.finally(e => dispatch(adjustmentsIsFetching(false)))
}

export const adjustmentRemove = (id) => (dispatch, state) => {
    dispatch(adjustmentsIsFetching(true))
    return remove(ADJUSTMENTS_API + '/' + id)
        .finally(e => dispatch(adjustmentsIsFetching(false)))
}
export const adjustmentsFetched = (payload) => ({ type: ADJUSTMENTS_FETCH, payload: payload })
export const adjustmentsIsFetching = (payload) => ({ type: ADJUSTMENTS_IS_FETCING, payload: payload })
export const adjustmentEdit = (id, data) => ({ type: ADJUSTMENT_EDIT, payload: data })
export const adjustmentFilter = (data) => ({ type: ADJUSTMENT_FILTER, payload: data })
export const setAdjustmentViewFilter = (data) => ({ type: SET_ADJUSTMENT_VIEW_FILTER, payload: data })
export const updateAdjustmentStatus = (data) => ({type: UPDATE_ADJUSTMENT_STATUS, payload: data})


// WEBPACK FOOTER //
// ./src/actions/adjustments.js